import script from "./BillingAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingAddress.vue?vue&type=script&setup=true&lang=ts"

import "./BillingAddress.vue?vue&type=style&index=0&id=25554573&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25554573"]])

export default __exports__